import { FeatureFlagsServiceBase } from '@skylab-shared/config';
import { FeatureFlagsRulesServiceBase } from '@skylab-shared/core';
import { dateDiffInDays } from '@skylab-shared/utils';

export const SplitPaymentFlag = 'split-payment';
export const IssueToInvoiceTinValidationFlag = 'issue-to-invoice-tin-validation';
export const JpkGroupsMppLawChangesFlag = 'jpk-groups-mpp-law-changes';

export class SaleFeatureFlagsRulesServiceBase {

    public constructor(
        private readonly featureFlagsService: FeatureFlagsServiceBase,
        private readonly featureFlagsRules: FeatureFlagsRulesServiceBase
    ) {}

    public configure(): void {
        this.configureSplitPaymentFlags();
        this.configureIssueToInvoiceTinValidationFlags();
        this.configureJpkGroupsMppLawChanges();
    }

    private configureSplitPaymentFlags(): void {
        this.featureFlagsRules.registerRule({
            id: 'split-payment::document-issued-after-feature-release-date',
            validate: (date: Date) => dateDiffInDays(this.featureFlagsService.flags.splitPaymentFeatureReleaseDate, date) <= 0
        });

        this.featureFlagsRules.registerFlag({
            name: SplitPaymentFlag,
            rules: ['split-payment::document-issued-after-feature-release-date']
        });
    }

    private configureJpkGroupsMppLawChanges(): void {
        this.featureFlagsRules.registerRule({
            id: 'jpk-groups-mpp-law-changes::tax-liability-date-after-feature-release-date',
            validate: (date: Date) => dateDiffInDays(this.featureFlagsService.flags.jpkGroupsMppLawChangesReleaseDate, date) <= 0
        });

        this.featureFlagsRules.registerFlag({
            name: JpkGroupsMppLawChangesFlag,
            rules: ['jpk-groups-mpp-law-changes::tax-liability-date-after-feature-release-date']
        });
    }

    private configureIssueToInvoiceTinValidationFlags(): void {
        this.featureFlagsRules.registerRule({
            id: 'issue-to-invoice-tin-validation::document-issued-after-feature-release-date',
            validate: () => dateDiffInDays(this.featureFlagsService.flags.issueToInvoiceTinValidationFeatureReleaseDate, new Date()) <= 0
        });

        this.featureFlagsRules.registerFlag({
            name: IssueToInvoiceTinValidationFlag,
            rules: ['issue-to-invoice-tin-validation::document-issued-after-feature-release-date']
        });
    }
}
